import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { Box } from '@mui/material'
import type { TemplateIcon as ITemplateIcon } from '@ulysses-inc/harami_api_client'
import type { Dispatch, FC, SetStateAction } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { templateIconTypes } from 'src/constants/templateIconTypes'
import { updateTemplateIcons } from 'src/state/ducks/templates/editTemplate/actions'
import type { RootState } from 'src/state/store'

const TemplateIcon: FC<{
  selectedTemplateIcon: ITemplateIcon
  activeIconState: [number, Dispatch<SetStateAction<number>>]
}> = ({
  selectedTemplateIcon: { iconType },
  activeIconState: [activeIcon, setActiveIcon],
}) => {
  const dispatch = useDispatch()
  const templateIcons = useSelector(
    (state: RootState) => state.templatesState.editTemplate.icons,
    shallowEqual,
  )

  const onClick = () => {
    dispatch(
      updateTemplateIcons(templateIcons.filter(i => i.iconType !== iconType)),
    )
    setActiveIcon(0)
  }

  const templateIcon = templateIconTypes.find(({ value }) => value === iconType)

  if (templateIcon === undefined) {
    return <></>
  }

  const { backgroundColor, svgComponent: SVG, label } = templateIcon

  return (
    <Box
      component="button"
      type="button"
      aria-label={`${label}（削除を表示）`}
      onMouseEnter={() => setActiveIcon(iconType ?? 0)}
      onMouseLeave={() => setActiveIcon(0)}
      onFocus={() => setActiveIcon(iconType ?? 0)}
      onBlur={() => setActiveIcon(0)}
      onClick={() =>
        setActiveIcon(prev => (prev === (iconType ?? 0) ? 0 : (iconType ?? 0)))
      }
      sx={{
        border: 0,
        p: 0,
        cursor: 'pointer',
        position: 'relative',
        width: 44,
        height: 44,
        bgcolor: backgroundColor,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {iconType === activeIcon && (
        <Box
          component="button"
          type="button"
          aria-label={`${label} を削除`}
          onClick={e => {
            e.stopPropagation()
            onClick()
          }}
          sx={{
            border: 0,
            p: 0,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            bgcolor: 'error.main',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
        >
          <DeleteOutlineIcon
            sx={{ width: 24, height: 24, color: 'common.white' }}
          />
        </Box>
      )}
      <SVG
        width={24}
        height={24}
        fill="#ffffff"
        role="img"
        aria-label={label}
      />
    </Box>
  )
}

export default TemplateIcon
